<template>
  <div class="col-md-3">
    <form-group-select
      v-if="options"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      placeholder="Selecione"
      @input="changeEstadoCivil($event)"
      @change="changeEstadoCivil($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import EstadoCivilService from "../../../domain/corpore/EstadoCivilService";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-estado-civil",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: {
      type: Boolean,
      default: true
    },
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  asyncComputed: {
    options() {
      this.service = new EstadoCivilService(this.$resource);
      return this.service.getEstadosCivis().then(estadosCivis => {
        return estadosCivis.map(estadoCivil => {
          return {
            value: estadoCivil.codigo,
            text: estadoCivil.descricao
          };
        });
      });
    }
  },
  methods: {
    changeEstadoCivil(estadoCivil) {
      this.$store.dispatch("setConjuge", false);

      if (estadoCivil === "C" || estadoCivil === "E") {
        this.$store.dispatch("setConjuge", true);
      }

      this.$emit("input", estadoCivil);
    }
  },
  mounted() {
    this.$el.value = this.value;
    this.changeEstadoCivil(this.value);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/EstadoCivil.vue